import { IUpdateDocumentoUseCase } from "../../../presentation/useCases/update/update_documento_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * UpdateDocumentoUseCase
 */

export class UpdateDocumentoUseCase implements IUpdateDocumentoUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) { }

  async updateDocumento(
    idFuncionarioDocumento: number,
    statusArquivo: number | null,
    nomeDocumento: string,
    dataVencimento: Date | null,
    dataEmissao: Date | null,
    file: File | null,
    limparArquivos: boolean,
  ): Promise<void> {
    await this.repository.updateDocumento(
      idFuncionarioDocumento,
      nomeDocumento,
      statusArquivo,
      dataVencimento,
      dataEmissao,
      file,
      limparArquivos,
    );
  }
}